import { http } from './http';

export type ServiceSummaryResponse = {
  machine: {
    id: string;
    name: string;
    model: string | null;
    brand: string | null;
    serialNumber: string[];
  };
  report: {
    id: string;
    provider: string;
    reportType: string;
    reportDate: string;
    common: {
      dateTime: string | null;
      startupDateTime: string | null;
      unitType: string | null;
      unitSerialNumber: string | null;
      softwareVersion: string | null;
    };
    sensors: Record<string, any>;
    serviceCounters: {
      Service_42_2?: { firstTime?: string; lastTime?: string; quantity?: string } | null;
      Service_43?: { firstTime?: string; lastTime?: string; quantity?: string } | null;
    };
    allSensors?: Record<string, { value?: any; unit?: string; max?: any }>;
    allServiceHistory?: Record<
      string,
      { firstTime?: string; lastTime?: string; quantity?: string } | null
    >;
  } | null;
};

export const serviceReportApi = {
  getServiceSummary: (token: string | null, machineId: string): Promise<ServiceSummaryResponse> =>
    http<ServiceSummaryResponse>(`/machines/${machineId}/service-summary`, { method: 'GET' }, token),
};


